import React from "react";
import axios from "axios";

import "./AppAnalytics.css";
import "./AppAnalyticsIcons.css";

const number = value => Number(value || 0).toLocaleString("id-ID");
const metricValue = (value, suffix = "") => value === null || value === undefined ? "N/A" : `${number(value)}${suffix}`;

const appIcons = {
  ypl: "/app-icons/ypl.png",
  general: "/app-icons/kliksekolah.png",
};

const Metric = ({ label, value, suffix = "" }) => (
  <div className="app-analytics-metric">
    <span>{label}</span>
    <strong>{metricValue(value, suffix)}</strong>
  </div>
);

const PlatformStatus = ({ platform }) => {
  const icon = platform.status === "live" ? "fas fa-check-circle" : "fas fa-exclamation-circle";
  return <span className={`app-analytics-status app-analytics-status--${platform.status}`}><i className={icon} />{platform.label}</span>;
};

class AppAnalytics extends React.Component {
  state = { data: null, period: 30, loading: true, error: "" };

  componentDidMount() {
    this.load(this.state.period);
  }

  load = async period => {
    this.setState({ period, loading: true, error: "" });
    try {
      const response = await axios.get(global.variable.LINK_API + "management/app-analytics", {
        ...global.variable.HEADERS_BEARER,
        cancelKey: "app-analytics",
        params: { period },
      });
      this.setState({ data: response.data });
    } catch (error) {
      if (axios.isCancel(error)) return;
      this.setState({ error: error?.response?.data?.message || "App Analytics belum dapat dimuat." });
    } finally {
      this.setState({ loading: false });
    }
  };

  renderAndroid = platform => {
    const metrics = platform.metrics || {};
    const maxDownload = Math.max(...(platform.trend || []).map(item => Number(item.downloads) || 0), 1);

    return (
      <article className="app-analytics-platform app-analytics-platform--android">
        <header>
          <span className="app-analytics-platform__icon"><i className="fab fa-android" /></span>
          <div><small>GOOGLE PLAY</small><h3>Android</h3><p>{platform.identifier}</p></div>
          <PlatformStatus platform={platform} />
        </header>
        <div className="app-analytics-platform__metrics">
          <Metric label="Download periode" value={metrics.period_downloads} />
          <Metric label="Install aktif" value={metrics.active_installs} />
          <Metric label="Uninstall periode" value={metrics.period_uninstalls} />
          <Metric label="DAU (GA4)" value={metrics.daily_active_users} />
          <Metric label="MAU (GA4)" value={metrics.monthly_active_users} />
          <Metric label="Retention" value={metrics.retention_rate} suffix="%" />
        </div>
        <div className="app-analytics-mini-chart">
          <div><strong>Tren download live</strong><span>{platform.message || `Data sampai ${platform.data_through || "N/A"}`}</span></div>
          <div className="app-analytics-mini-chart__bars">
            {(platform.trend || []).map(item => <span key={item.date} title={`${item.date}: ${number(item.downloads)}`}><i style={{ height: `${Math.max(8, (Number(item.downloads) / maxDownload) * 100)}%` }} /></span>)}
          </div>
        </div>
      </article>
    );
  };

  renderIos = platform => {
    const metrics = platform.metrics || {};
    const maxDownload = Math.max(...(platform.trend || []).map(item => Number(item.downloads) || 0), 1);

    return (
      <article className="app-analytics-platform app-analytics-platform--ios">
        <header>
          <span className="app-analytics-platform__icon"><i className="fab fa-apple" /></span>
          <div><small>APP STORE CONNECT</small><h3>iOS</h3><p>{platform.identifier}</p></div>
          <PlatformStatus platform={platform} />
        </header>
        <div className="app-analytics-platform__metrics">
          <Metric label="Download periode" value={metrics.period_downloads} />
          <Metric label="Sesi periode" value={metrics.sessions} />
          <Metric label="Install aktif" value={metrics.active_installs} />
          <Metric label="Uninstall periode" value={metrics.period_uninstalls} />
          <Metric label="DAU (GA4)" value={metrics.daily_active_users} />
          <Metric label="MAU (GA4)" value={metrics.monthly_active_users} />
        </div>
        <div className="app-analytics-mini-chart">
          <div><strong>Tren download live</strong><span>{platform.message || `Data sampai ${platform.data_through || "N/A"}`}</span></div>
          <div className="app-analytics-mini-chart__bars">
            {(platform.trend || []).map(item => <span key={item.date} title={`${item.date}: ${number(item.downloads)}`}><i style={{ height: `${Math.max(8, (Number(item.downloads) / maxDownload) * 100)}%` }} /></span>)}
          </div>
        </div>
      </article>
    );
  };

  render() {
    const { data, period, loading, error } = this.state;
    const summary = data?.summary || {};

    if (loading && !data) return <div className="app-analytics-state"><span className="app-analytics-loader" /><h2>Menyiapkan App Analytics</h2><p>Menggabungkan status Google Play dan App Store Connect.</p></div>;
    if (error && !data) return <div className="app-analytics-state app-analytics-state--error"><i className="fas fa-exclamation-triangle" /><h2>App Analytics tidak dapat dimuat</h2><p>{error}</p><button type="button" onClick={() => this.load(period)}>Coba lagi</button></div>;

    return (
      <section className="app-analytics-page">
        <header className="app-analytics-hero">
          <div><span><i className="fas fa-mobile-alt" /> MOBILE INTELLIGENCE</span><h1>App Analytics</h1><p>Aktivasi, instalasi, dan engagement aplikasi Pangudi Luhur dan Kliksekolah.</p></div>
          <div className="app-analytics-controls"><small>Periode tampilan</small><div><select value={period} onChange={event => this.load(event.target.value === "all" ? "all" : Number(event.target.value))}><option value={7}>7 hari</option><option value={30}>30 hari</option><option value={90}>90 hari</option><option value="all">Semua waktu</option></select><button type="button" onClick={() => this.load(period)} disabled={loading}><i className={`fas fa-sync-alt ${loading ? "fa-spin" : ""}`} /></button></div></div>
        </header>

        <div className={`app-analytics-demo-alert ${data?.mode === "live" ? "app-analytics-live-alert" : ""}`}><i className={data?.mode === "live" ? "fas fa-satellite-dish" : "fas fa-exclamation-triangle"} /><div><strong>{data?.mode === "live" ? "Data provider live" : "Sebagian provider belum tersedia"}</strong><p>{data?.notice}</p></div></div>
        {error && <div className="app-analytics-error"><i className="fas fa-info-circle" /> {error}</div>}

        <div className="app-analytics-kpis">
          <article><span><i className="fas fa-download" /></span><div><small>Total download</small><strong>{number(summary.period_downloads)}</strong><p>{data?.period_label}</p></div></article>
          <article><span><i className="fab fa-google-play" /></span><div><small>Download Android</small><strong>{number(summary.android_downloads)}</strong><p>Google Play</p></div></article>
          <article><span><i className="fab fa-apple" /></span><div><small>Download iOS</small><strong>{number(summary.ios_downloads)}</strong><p>App Store Connect</p></div></article>
          <article><span><i className="fas fa-play-circle" /></span><div><small>Sesi iOS</small><strong>{number(summary.sessions)}</strong><p>App Store Connect</p></div></article>
        </div>

        <div className="app-analytics-source-strip">
          <div><span className="app-analytics-source-strip__android"><i className="fab fa-google-play" /></span><div><small>GOOGLE PLAY</small><strong>{data?.sources?.google_play?.label}</strong><p>{data?.sources?.google_play?.message}</p></div></div>
          <div><span className="app-analytics-source-strip__ios"><i className="fab fa-apple" /></span><div><small>APP STORE CONNECT</small><strong>{data?.sources?.app_store?.label}</strong><p>{data?.sources?.app_store?.message}</p></div></div>
        </div>

        {(data?.apps || []).map(app => (
          <section className="app-analytics-app" key={app.key}>
            <header><span className="app-analytics-app__icon"><img src={appIcons[app.key]} alt={`Icon ${app.name}`} /></span><div><small>MOBILE APPLICATION</small><h2>{app.name}</h2></div></header>
            <div className="app-analytics-platform-grid">
              {this.renderAndroid(app.platforms.android)}
              {this.renderIos(app.platforms.ios)}
            </div>
          </section>
        ))}

        <footer className="app-analytics-footnote"><i className="fas fa-shield-alt" /><span><strong>Semua angka berasal dari report provider.</strong> DAU dan MAU tetap N/A sampai Firebase/GA4 dikonfigurasi; tanggal terbaru mengikuti keterlambatan publikasi masing-masing provider.</span></footer>
      </section>
    );
  }
}

export default AppAnalytics;
